import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Reveal, SectionBadge } from "@/components/Reveal";
import Logo from "@/components/Logo";
import { useLang } from "@/lib/i18n";

export default function Terms() {
  const { t } = useLang();
  const sections = t("terms.sections");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="terms-page" className="relative min-h-screen bg-[#0B0C0E] text-[#EAE6E1]">
      <div className="noise-overlay" aria-hidden="true" />

      <header className="fixed top-0 left-0 right-0 z-50 border-b border-[#262930] bg-[#0B0C0E]/80 backdrop-blur-xl">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="terms-logo">
            <Logo />
          </Link>
          <Link
            to="/"
            data-testid="terms-back-link"
            className="flex items-center gap-1.5 text-sm text-[#9E9E9E] transition-colors duration-200 hover:text-[#EAE6E1]"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("terms.back")}
          </Link>
        </div>
      </header>

      <main className="pt-32 md:pt-40 pb-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <SectionBadge label={t("terms.badge")} testId="terms-badge" />
            <h1 className="font-display mt-6 text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.08] text-[#EAE6E1]">
              {t("terms.title")}
            </h1>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-[#9E9E9E]">
              {t("terms.sub")}
            </p>
          </Reveal>

          <div className="mt-14 space-y-6">
            {sections.map((s, i) => (
              <Reveal key={s.num} delay={i * 0.08}>
                <div
                  data-testid={`terms-section-${i}`}
                  className="rounded-xl border border-[#262930] bg-[#121418] p-7 transition-colors duration-200 hover:border-[#3A3F4B]"
                >
                  <div className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#C87A5B]">
                    {t("terms.sectionLabel")} {s.num}
                  </div>
                  <h2 className="font-display mt-3 text-xl font-semibold tracking-tight text-[#EAE6E1]">
                    {s.title}
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-[#9E9E9E]">{s.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </main>

      <footer className="border-t border-[#262930] py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="font-tech text-[10px] uppercase tracking-[0.2em] text-[#686D76]">
            {t("terms.footer")}
          </span>
        </div>
      </footer>
    </div>
  );
}
